import script from "./sf-table-header.vue?vue&type=script&setup=true&lang=ts&generic=HD%20extends%20BaseHeader"
export * from "./sf-table-header.vue?vue&type=script&setup=true&lang=ts&generic=HD%20extends%20BaseHeader"

import "./sf-table-header.vue?vue&type=style&index=0&id=77a8d4a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a8d4a0"]])

export default __exports__